import React from 'react';
import { useDevice, useViewport } from '@treatwell/ui';
import { CMSTreatwellRewardsPage } from 'js/model/cms/cms-treatwell-rewards';
import { BannerCTA } from '../BannerCTA';
import { LoyaltyContainer } from '../LoyaltyContainer';
import styles from './FooterBannerSection.module.css';
import footerMobile from './assets/footerMobile.webp';

type FooterBannerSectionProps = {
  cmsValues: CMSTreatwellRewardsPage;
};

export const FooterBannerSection = ({
  cmsValues,
}: FooterBannerSectionProps) => {
  const { isMobile } = useDevice();
  const isMobileViewport = useViewport({
    device: ['mobile', 'tablet'],
    serverRender: isMobile,
  });
  const cms = cmsValues.page['treatwell-rewards'].footer;
  return (
    <section className={styles.root}>
      <LoyaltyContainer>
        <BannerCTA
          title={cms.title}
          cta={{
            label: cms.cta.label,
          }}
          align="center"
        />
      </LoyaltyContainer>
      {isMobileViewport && (
        <div className={styles.img}>
          <img src={footerMobile} height="274" width="375" alt="" />
        </div>
      )}
    </section>
  );
};
